/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

function SEO({ description, lang, meta, title, cardTitle, imageRelativeUrl, useLargeImageCard }) {
  const { site, defaultImage } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            siteUrl
          }
        }
        defaultImage: file(relativePath: {eq: "progmiscon-logo-500-plus-margin-white-bg.png"}) {
          childImageSharp {
            fixed(width: 512, height: 512) {
              src
            }
          }
        }
      }
    `
  )
  
  const metaDescription = description || site.siteMetadata.description
  
  const twitterCardType = useLargeImageCard ? 'summary_large_image' : 'summary'
  const defaultImageRelativeUrl = defaultImage.childImageSharp.fixed.src
  const imageUrl = site.siteMetadata.siteUrl + ( imageRelativeUrl ? imageRelativeUrl : defaultImageRelativeUrl )

  title = title || site.siteMetadata.title
  cardTitle = cardTitle || (title || site.siteMetadata.title)

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        // Facebook
        // https://developers.facebook.com/docs/sharing/webmasters#markup
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:title`,
          content: cardTitle,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:image`,
          content: imageUrl,
        },
        // Twitter
        // https://developer.twitter.com/en/docs/twitter-for-websites/cards/
        {
          name: `twitter:card`,
          content: twitterCardType,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:site`,
          content: `@progmiscon`,
        },
        {
          name: `twitter:title`,
          content: cardTitle,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {
          name: `twitter:image`,
          content: imageUrl,
        },
      ].concat(meta)}
    />
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
  title: undefined
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string,
}

export default SEO
